var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg018Empty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000123412476363231996370000014283852594975777959_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#E5EEF8;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000064339844412440850740000003137092723887234979_);}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000067940971223437891530000014452754501543660704_);}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000124853375375462971500000017546494550177761967_);}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000093890580854458330580000013655510099518623107_);}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000016059477683458231220000017314457208722901685_);}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000102505960296438870840000017965226594094194613_);}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000173159586428188626770000008559165759721927312_);}\r\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000103236260671330659360000012601475247580200105_);}\r\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000029725355862462026320000016231032750804789940_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Exp-3.-G"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -702.0926,
    y1: 806.0668,
    x2: -701.0339,
    y2: 806.0668,
    gradientTransform: "matrix(-23.008 78.848 78.848 23.008 -79388.0312 37075.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9B57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED7C2F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.9,253.7L252,343.5c0,0,31.9-10,77.9,6c7.7,2.7,20.6-10.2,18-18C331.9,285.6,341.9,253.7,341.9,253.7 L341.9,253.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038385161476684339290000015634007063045490082_",
    gradientUnits: "userSpaceOnUse",
    x1: -700.2071,
    y1: 798.0844,
    x2: -699.1484,
    y2: 798.0844,
    gradientTransform: "matrix(184.864 168.44 168.44 -184.864 -4878.5713 265597.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9EFE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000038385161476684339290000015634007063045490082_)"
    },
    d: " M101.5,103.1c54.5-54.5,143.1-54.5,197.6,0c54.5,54.5,54.5,143.1,0,197.6c-54.5,54.5-143.1,54.5-197.6,0 C46.9,246.2,46.9,157.6,101.5,103.1L101.5,103.1z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281,87.8c6.3,4.5,12.4,9.6,18.1,15.3c54.5,54.5,54.5,143.1,0,197.6c-54.5,54.5-143.1,54.5-197.6,0 c-3.2-3.2-6.2-6.5-9.1-10c52.9,17.2,113.3,4.8,155.3-37.2C292.4,208.8,303.5,143,281,87.8L281,87.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096052749308611040410000003417226372044250804_",
    gradientUnits: "userSpaceOnUse",
    x1: -701.2836,
    y1: 799.2615,
    x2: -700.2249,
    y2: 799.2615,
    gradientTransform: "matrix(53.392 238.512 238.512 -53.392 -153016.3906 210023.8125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4BBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8DA3BE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000096052749308611040410000003417226372044250804_)"
    },
    d: " M89.5,91.1c61.2-61.2,160.4-61.2,221.6,0s61.2,160.4,0,221.6s-160.4,61.2-221.6,0S28.3,152.2,89.5,91.1z M107.4,109.1 c51.2-51.2,134.4-51.2,185.7,0s51.2,134.4,0,185.7s-134.4,51.2-185.7,0S56.2,160.3,107.4,109.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145779917563413099430000005128029238859191686_",
    gradientUnits: "userSpaceOnUse",
    x1: -700.7956,
    y1: 799.7135,
    x2: -699.7369,
    y2: 799.7135,
    gradientTransform: "matrix(67.264 204.904 204.904 -67.264 -116602.0781 197446.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFD9CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4BBDB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000145779917563413099430000005128029238859191686_)"
    },
    d: " M59.9,271.6C30.8,213,40.7,139.9,89.5,91.1c45.8-45.8,113.1-57.3,169.6-34.5c0.4,5.2,0.6,10.5,0.6,15.8c0,4.1-0.1,8.2-0.4,12.2 C210.1,59.8,148.5,68,107.4,109.1c-43.5,43.5-50.1,110.2-19.6,160.7c-8.9,1.2-18,1.9-27.3,1.9L59.9,271.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134240858909375487510000003811389094081957781_",
    gradientUnits: "userSpaceOnUse",
    x1: -703.8492,
    y1: 805.8697,
    x2: -702.7905,
    y2: 805.8697,
    gradientTransform: "matrix(-38.728 74.408 74.408 38.728 -86804.0859 21536.9824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4BBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8DA3BE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000134240858909375487510000003811389094081957781_)"
    },
    d: " M323,378.6c-14.9-14.9-14.9-39,0-53.9c14.9-14.9,39-14.9,53.9,0l122.8,122.8c3.3,3.3-6.1,18.1-21,32.9 c-14.9,14.9-29.6,24.3-32.9,21L323,378.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029005460591810474260000005287511032739448213_",
    gradientUnits: "userSpaceOnUse",
    x1: -703.3631,
    y1: 806.7569,
    x2: -702.3044,
    y2: 806.7569,
    gradientTransform: "matrix(-31.616 70.208 70.208 31.616 -78467.0859 24242.5137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9EFE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFD9CB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000029005460591810474260000005287511032739448213_)"
    },
    d: " M323,378.6c-14.9-14.9-14.9-39,0-53.9c14.9-14.9,39-14.9,53.9,0l111.1,111.1c3.3,3.3-6.1,18.1-21,32.9s-29.6,24.3-32.9,21 L323,378.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103965675587513075510000005148029106323049646_",
    gradientUnits: "userSpaceOnUse",
    x1: -699.5806,
    y1: 801.4059,
    x2: -698.5219,
    y2: 801.4059,
    gradientTransform: "matrix(40.88 131.552 131.552 -40.88 -76640.0078 124923.2812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9B57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED7C2F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000103965675587513075510000005148029106323049646_)"
    },
    d: " M182.3,175.2c-0.2-8.1,2.8-14,7.5-17.4c7.4-5.4,18.3-5.2,24.3,1.5c2.6,2.9,4,7,4.1,12.1c0.1,12.4-5.7,19.6-11.4,27.1 c-7.7,10.1-15.3,20.5-16.3,37.8c-0.3,4.7,3.3,8.7,8,8.9c4.7,0.3,8.7-3.3,8.9-8c0.7-13.2,7-20.8,12.8-28.5 c7.8-10.3,15-20.5,14.8-37.5c-0.1-10-3.4-17.7-8.4-23.2c-11.6-13-32.8-14.4-47-3.9c-8.5,6.3-14.7,16.7-14.4,31.5 c0.1,4.7,4,8.4,8.7,8.3C178.7,183.8,182.4,179.9,182.3,175.2L182.3,175.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089544171808264905200000015253697505490011833_",
    gradientUnits: "userSpaceOnUse",
    x1: -699.5806,
    y1: 801.1866,
    x2: -698.5219,
    y2: 801.1866,
    gradientTransform: "matrix(40.88 131.552 131.552 -40.88 -76640.0078 124923.2812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9B57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED7C2F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000089544171808264905200000015253697505490011833_)"
    },
    cx: 198.2,
    cy: 266.4,
    r: 10.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116916355294020428300000004872855696547811490_",
    gradientUnits: "userSpaceOnUse",
    x1: -706.363,
    y1: 801.8369,
    x2: -705.3043,
    y2: 801.8369,
    gradientTransform: "matrix(-97.864 72.792 72.792 97.864 -127081.3672 -27064.3906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9B57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED7C2F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000116916355294020428300000004872855696547811490_)"
    },
    d: " M350.7,57.2l25.4-42.3c2.4-4,1.1-9.2-2.9-11.6c-4-2.4-9.2-1.1-11.6,2.9l-25.4,42.3c-2.4,4-1.1,9.2,2.9,11.6 C343.1,62.5,348.3,61.2,350.7,57.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136395137566431794570000011652210524611553214_",
    gradientUnits: "userSpaceOnUse",
    x1: -706.363,
    y1: 802.2935,
    x2: -705.3043,
    y2: 802.2935,
    gradientTransform: "matrix(-97.864 72.792 72.792 97.864 -127081.3672 -27064.3906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9B57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED7C2F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000136395137566431794570000011652210524611553214_)"
    },
    d: " M390.7,85.1l93.2-67.8c3.8-2.8,4.6-8.1,1.9-11.8c-2.8-3.8-8.1-4.6-11.8-1.9l-93.2,67.8c-3.8,2.8-4.6,8.1-1.9,11.8 C381.7,87,387,87.8,390.7,85.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176020304986096558190000016976141233448171174_",
    gradientUnits: "userSpaceOnUse",
    x1: -706.363,
    y1: 802.8156,
    x2: -705.3043,
    y2: 802.8156,
    gradientTransform: "matrix(-97.864 72.792 72.792 97.864 -127081.3672 -27064.3906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9B57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED7C2F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000176020304986096558190000016976141233448171174_)"
    },
    d: " M404.7,137.3l67.8-16.9c4.5-1.1,7.3-5.7,6.2-10.3c-1.1-4.5-5.7-7.3-10.3-6.2l-67.8,16.9c-4.5,1.1-7.3,5.7-6.2,10.3 C395.6,135.6,400.2,138.4,404.7,137.3L404.7,137.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg018Empty);
export default __webpack_public_path__ + "static/media/018-empty.f8fd5b85adee0569b74e16c79cfafc38.svg";
export { ForwardRef as ReactComponent };